<template>
  <div class="grow text-center my-1 ml-1" dir="rtl">
    <slot />
  </div>
</template>

<script setup lang="ts"></script>
